module.exports = __webpack_public_path__ + "assets_app/img/plus-button.56de0c8c.png";